<!--  -->
<template>
  <div class='xuexi round bj-col-white pad'>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="专业科目(学习)" name="1">
        <xuan-ke v-if="activeName == '1'"></xuan-ke>
      </el-tab-pane>
      <el-tab-pane label="公需科目(学习)" name="2">
        <gong-xu v-if="activeName == '2'" @noAuth="activeName = '1'"></gong-xu>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import GongXu from './tabs/gongxu.vue'
import XuanKe from './tabs/xuanke.vue'

export default {
  components: {
    GongXu,
    XuanKe
  },
  data() {
    return {
      activeName: '1'
    };
  },
  computed: {},
  watch: {
    
  },
  created() {
    this.activeName = localStorage.getItem('gx_zy') || '1'
    localStorage.removeItem('gx_zy')
  },
  mounted() {
    
  },
  //方法集合
  methods: {
    
  },
}
</script>

<style lang='less' scoped>
.xuexi {
  /deep/ .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>